var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailcreate1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1330_3968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1330_3968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41356 15.4375C3.01363 15.4375 2.67513 15.299 2.39805 15.0219C2.12096 14.7448 1.98242 14.4063 1.98242 14.0064V4.99364C1.98242 4.59371 2.12096 4.25521 2.39805 3.97813C2.67513 3.70104 3.01363 3.5625 3.41356 3.5625H15.593C15.9929 3.5625 16.3314 3.70104 16.6085 3.97813C16.8855 4.25521 17.0241 4.59371 17.0241 4.99364V14.0064C17.0241 14.4063 16.8855 14.7448 16.6085 15.0219C16.3314 15.299 15.9929 15.4375 15.593 15.4375H3.41356ZM9.50326 9.94155L3.16992 5.89178V14.0064C3.16992 14.0775 3.19275 14.1359 3.2384 14.1815C3.28405 14.2272 3.34244 14.25 3.41356 14.25H15.593C15.6641 14.25 15.7225 14.2272 15.7681 14.1815C15.8138 14.1359 15.8366 14.0775 15.8366 14.0064V5.89178L9.50326 9.94155ZM9.50326 8.70833L15.7149 4.75H3.29164L9.50326 8.70833ZM3.16992 5.89178V4.75V14.0064C3.16992 14.0775 3.19275 14.1359 3.2384 14.1815C3.28405 14.2272 3.34244 14.25 3.41356 14.25H3.16992V5.89178Z",
    fill: "#001E40",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailcreate1);
export default __webpack_public_path__ + "static/media/mailcreate (1).273d1681fa12b0d6af86305393af9c1a.svg";
export { ForwardRef as ReactComponent };